import pxToRem from "../../functions/pxToRem";

const root = {
  display: "inline-flex" as const,
  justifyContent: "center" as const,
  alignItems: "center" as const,
  fontSize: pxToRem(14),
  fontWeight: 500,
  borderRadius: pxToRem(4),
  padding: `${pxToRem(5)} ${pxToRem(16)}`,
  lineHeight: 1.5,
  textAlign: "center" as const,
  textTransform: "none" as const,
  userSelect: "none" as const,
  backgroundSize: "150% 150%",
  backgroundPosition: "50%",
  transition:
    "background-color 150ms cubic-bezier(0.33, 0, 0.67, 1), border-color 150ms cubic-bezier(0.33, 0, 0.67, 1), color 150ms cubic-bezier(0.33, 0, 0.67, 1), transform 100ms cubic-bezier(0.33, 0, 0.67, 1)",
  letterSpacing: 0,
  cursor: "pointer" as const,
  border: "none",

  "&:disabled": {
    pointerEvent: "none",
    opacity: 0.65,
    cursor: "not-allowed",
  },

  "& .material-icons": {
    fontSize: pxToRem(16),
    marginTop: pxToRem(-2),
  },

  "&:active": {
    transform: "scale(0.985)",
  },
};

export default root;
